export default __webpack_public_path__ + "static/nick_karpov-4f8f7b067a54df72b0ebc83babeadee6.jpg";